// ============================================================================
// DOM helpers — element refs and the $() lookup helper
// ============================================================================

export const $ = (id) => document.getElementById(id);

// ---- layout ----
export const sidebar = $("sidebar");
export const sbList = $("sb-list");
export const sbNew = $("sb-new");
export const sbFooter = $("sb-footer");
export const onboarding = $("onboarding");
export const chatView = $("chat-view");
export const dirDisplay = $("dir-display");
export const dirPath = $("dir-path");
export const onboardStart = $("onboard-start");
export const recentDirs = $("recent-dirs");
export const sessionSub = $("session-sub");
export const dirBadge = $("dir-badge");
export const toggleSidebarBtn = $("toggle-sidebar");
export const sidebarOverlay = $("sidebar-overlay");
export const typingIndicator = $("typing-indicator");
export const attachBtn = $("attach-btn");
export const fileInput = $("file-input");
export const sbFilesBtn = $("sb-files");

// ---- file viewer ----
export const fvOverlay = $("fv-overlay");
export const fvClose = $("fv-close");
export const fvBreadcrumb = $("fv-breadcrumb");
export const fvPathInput = $("fv-path");
export const fvUp = $("fv-up");
export const fvHome = $("fv-home");
export const fvGo = $("fv-go");
export const fvNewFile = $("fv-new-file");
export const fvUpload = $("fv-upload");
export const fvUploadInput = $("fv-upload-input");
export const fvSortKey = $("fv-sort-key");
export const fvSortDir = $("fv-sort-dir");
export const fvFilter = $("fv-filter");
export const fvHidden = $("fv-hidden");
export const fvList = $("fv-list");
export const fvTabs = $("fv-tabs");
export const fvPaneFiles = $("fv-pane-files");
export const fvDiffPane = $("fv-diff-pane");
export const fvDiffBase = $("fv-diff-base");
export const fvDiffModeSelect = $("fv-diff-mode-select");
export const fvDiffSort = $("fv-diff-sort");
export const fvDiffFilter = $("fv-diff-filter");
export const fvDiffRefresh = $("fv-diff-refresh");
export const fvDiffSummary = $("fv-diff-summary");
export const fvDiffTree = $("fv-diff-tree");
export const fvPickRecents = $("fv-pick-recents");
export const fvPickFoot = $("fv-pick-foot");
export const fvPickSelected = $("fv-pick-selected");
export const fvPickConfirm = $("fv-pick-confirm");
export const fvPickCancel = $("fv-pick-cancel");

// ---- pins ----
export const pinStrip = $("pin-strip");
export const pinPeekOverlay = $("pin-peek-overlay");
export const pinPeekTitle = $("pin-peek-title");
export const pinPeekBody = $("pin-peek-body");
export const pinPeekOpen = $("pin-peek-open");
export const pinPeekUnpin = $("pin-peek-unpin");
export const pinPeekClose = $("pin-peek-close");

// ---- composer ----
export const messagesEl = $("messages");
export const scrollBottomBtn = $("scroll-bottom");
export const inner = $("messages-inner");
export const input = $("input");
export const sendBtn = $("send-btn");
export const stopBtn = $("stop-btn");
export const composerHint = $("composer-hint");
export const pastePreview = $("paste-preview");
export const composerInput = $("composer-input");
export const queuedTray = $("queued-tray");
export const reconnectBanner = $("reconnect-banner");
export const reconnectBtn = $("reconnect-btn");

// ---- shells + stats ----
export const sbShellsBtn = $("sb-shells");
export const sbShellsBadge = $("sb-shells-badge");
export const sbStatsBtn = $("sb-stats-btn");
export const statsOverlay = $("stats-overlay");
export const statsClose = $("stats-close");
export const statsContent = $("stats-content");
export const sbSessionsBtn = $("sb-sessions-btn");
export const sbSessionsBadge = $("sb-sessions-badge");
export const sessionsOverlay = $("sessions-overlay");
export const sessionsClose = $("sessions-close");
export const sessionsContent = $("sessions-content");
export const terminalOverlay = $("terminal-overlay");
export const terminalTabs = $("terminal-tabs");
export const terminalNew = $("terminal-new");
export const terminalClose = $("terminal-close");
export const terminalContainer = $("terminal-container");

// ---- model picker ----
export const modelPickerBtn = $("model-picker-btn");
export const mpOverlay = $("mp-overlay");
export const mpClose = $("mp-close");
export const mpCurrent = $("mp-current");
export const mpSearch = $("mp-search");
export const mpList = $("mp-list");

// ---- slash command picker ----
export const cmdOverlay = $("cmd-overlay");
export const cmdInput = $("cmd-input");
export const cmdList = $("cmd-list");
export const modeBadge = $("mode-badge");
export const modeMenu = $("mode-menu");
export const modeMenuList = $("mode-menu-list");
export const modeOverlay = $("mode-overlay");

// ---- @-mention file picker ----
export const fmOverlay = $("fm-overlay");
export const fmList = $("fm-list");
export const fmQuery = $("fm-query");
